import ValidateModule from "./ValidateModule";

import type AjaxRequestBroker from "../AjaxRequestBroker";
import type { IEventChannel } from "../model/Models";
import type CacheModule from "./CacheModule";

const es = global.es;

export default class HeuristicsModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;

    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     * @param resourceName 
     * @param cache 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;

        this.isZip = this.isZip.bind(this);
        this.isPostCode = this.isPostCode.bind(this);
        this.isLatitude = this.isLatitude.bind(this);
        this.isLongitude = this.isLongitude.bind(this);
        this.is = this.is.bind(this);
    }

    /**
     * Checks, based on attribute title, if an attribute can be used as zip
     * 
     * @param attrTitle
     * 
     * @return a jquery deferred object resolved when the request has completed
     */
    isZip(attrTitle: string) {
        return this.is('zip', attrTitle);
    }
    
    /**
     * Checks, based on attribute title, if an attribute can be used post code
     * 
     * @param attrTitle
     * 
     * @return a jquery deferred object resolved when the request has completed
     */
    isPostCode(attrTitle: string) {
        return this.is('post_code', attrTitle);
    }
    
    /**
     * Checks, based on attribute title, if an attribute can be used latitude
     * 
     * @param attrTitle
     * 
     * @return a jquery deferred object resolved when the request has completed
     */
    isLatitude(attrTitle: string) {
        return this.is('latitude', attrTitle);
    }
    
    /**
     * Checks, based on attribute title, if an attribute can be used longitude
     * 
     * @param attrTitle
     * 
     * @return a jquery deferred object resolved when the request has completed
     */
    isLongitude(attrTitle: string) {
        return this.is('longitude', attrTitle);
    }
    
    /**
     * 
     * @param type 
     * @param attrTitle 
     * 
     * @returns 
     */
    private is(type: string, attrTitle: string) {
        if (!ValidateModule.checkMandatoryArg(type) || !ValidateModule.checkMandatoryArg(attrTitle)) {
            return es.util.deferred.rejected();
        }
        
        var url = es.api.getURL(this.resourceName) + "/" + type + "?attrTitle=" + es.util.url.stringify(attrTitle);
        return this.cache.doGet(this.rqBroker, this.resourceName, url, attrTitle.replace(/[\W]+/g, '_'));
    }
}
